import { render, staticRenderFns } from "./SettlementSummaryComparison.vue?vue&type=template&id=e73fbd34&scoped=true&lang=pug"
import script from "./SettlementSummaryComparison.vue?vue&type=script&lang=ts"
export * from "./SettlementSummaryComparison.vue?vue&type=script&lang=ts"
import style0 from "./SettlementSummaryComparison.vue?vue&type=style&index=0&id=e73fbd34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73fbd34",
  null
  
)

export default component.exports